import * as actions from "./actionsType";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  statusesLength: 0,
  statuses: [],
  status: {},
  statusError: "",
  formError: "",
};

export default function StatusReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_STATUS:      
      return { ...state, loading: action.payload };

    case actions.LOADING_STATUS_BY_ID:
      return { ...state, loadingById: action.payload };

    case actions.SAVE_LOADING_STATUS:
      return { ...state, saveLoading: action.payload };

    case actions.GET_STATUS:
      return {
        ...state,
        statuses: action.payload.statuses,
        statusesLength: action.payload.statusesLength,
      };

    case actions.GET_STATUS_BY_ID:
      return { ...state, status: action.payload };

    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };

    case actions.STATUS_FAIL:
      return { ...state, statusError: action.payload };

    default:
      return state;
  }
}
